import { render, staticRenderFns } from "./OffPeakDining.vue?vue&type=template&id=70f03ae1&scoped=true"
import script from "./OffPeakDining.vue?vue&type=script&lang=js"
export * from "./OffPeakDining.vue?vue&type=script&lang=js"
import style0 from "./OffPeakDining.vue?vue&type=style&index=0&id=70f03ae1&prod&lang=scss&scoped=true"
import style1 from "./OffPeakDining.vue?vue&type=style&index=1&id=70f03ae1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f03ae1",
  null
  
)

export default component.exports